export const testimonials = [
  {
    id: "testimonial-1",
    name: "Marcus Reynolds",
    title: "Director of Operations",
    company: "Westfield Commercial Properties",
    quote: "Askari Security Services transformed our property management approach. Their patrol team reduced unauthorized access incidents by 94% within the first three months. The professionalism and attention to detail is unmatched.",
    rating: 5,
  },
  {
    id: "testimonial-2",
    name: "Elena Vasquez",
    title: "HOA President",
    company: "Highland Estates, Pasadena",
    quote: "We switched to Askari after a series of break-ins. Their unarmed patrol service has been a game-changer. Residents finally feel safe walking their dogs at night. The 24/7 dispatch center gives us peace of mind.",
    rating: 5,
  },
  {
    id: "testimonial-3",
    name: "David Chen",
    title: "Event Coordinator",
    company: "SoCal Music Festival",
    quote: "Managing crowd control for 50,000+ attendees requires elite professionals. Askari's event security team handled entry, perimeter control, and emergency response flawlessly. We will not host another event without them.",
    rating: 5,
  },
  {
    id: "testimonial-4",
    name: "Sarah Mitchell",
    title: "VP of Human Resources",
    company: "Pinnacle Industries",
    quote: "Our executive protection detail from Askari is exceptional. The team is discreet, highly trained, and adaptable to changing schedules and international travel requirements. They operate like a seamless extension of our company.",
    rating: 5,
  },
  {
    id: "testimonial-5",
    name: "James Okonkwo",
    title: "Project Manager",
    company: "Pacific Builders LLC",
    quote: "Construction sites are prime targets for theft. Askari's overnight security and equipment monitoring saved us over $200,000 in potential losses last year alone. Their guards are vigilant and knowledgeable about construction operations.",
    rating: 5,
  },
];